import { Injectable, inject } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  protected toastCtrl = inject(ToastController);

  async show(
    message: string,
    duration = 2000,
    position: 'top' | 'middle' | 'bottom' = 'bottom',
    color?:
      | 'primary'
      | 'secondary'
      | 'tertiary'
      | 'success'
      | 'warning'
      | 'danger'
      | 'light'
      | 'medium'
      | 'dark'
  ) {
    const toast = await this.toastCtrl.create({
      message,
      duration,
      position,
      color
    });
    await toast.present();
  }
}
